export function createPollingState() {
  return { latestStarted: 0, latestApplied: 0, inFlight: false };
}

export function beginPollingRequest(state) {
  if (state.inFlight) return null;

  state.inFlight = true;
  state.latestStarted += 1;
  return state.latestStarted;
}

export function finishPollingRequest(state, sequence) {
  if (sequence === state.latestStarted) state.inFlight = false;
}

export function invalidatePollingRequests(state) {
  state.latestStarted += 1;
  state.inFlight = false;
}

export function pollingAllowed({ connected = true, hidden = false, inFlight = false } = {}) {
  return connected && !hidden && !inFlight;
}

export function applyPollingResponse(state, sequence, apply) {
  if (sequence !== state.latestStarted || sequence <= state.latestApplied) return false;

  apply();
  state.latestApplied = sequence;
  return true;
}

export function retryDelayMilliseconds(headerValue, fallback = 5000) {
  const seconds = Number.parseInt(headerValue, 10);
  if (!Number.isFinite(seconds) || seconds <= 0) return fallback;

  return Math.min(seconds * 1000, 60_000);
}
